// state/simula-session.ts — W2.3: cross-component reset signal for Simula.
//
// SimulaScreen owns its state machine via local React useState, but the
// LeftDrawer also lives inside the Review sub-component which doesn't have
// access to the parent's setters. To handle "user clicks Simula in the
// drawer while currently in Running / PostMortem / Review", drawer-nav bumps
// this counter; SimulaScreen subscribes and resets back to the picker phase
// in an effect.
//
// The counter starts at 0; the consuming effect short-circuits on 0 so it
// doesn't fire on the initial mount.

import { create } from 'zustand';

interface SimulaSessionState {
  resetCounter: number;
  triggerReset: () => void;
}

export const useSimulaSession = create<SimulaSessionState>((set) => ({
  resetCounter: 0,
  triggerReset: () => set((s) => ({ resetCounter: s.resetCounter + 1 })),
}));
